











































import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import S3Image from '@/components/S3Image.vue';
import AnimalSubscribe from '@/modules/user/subscriptions/_components/AnimalSubscribe.vue';
import Loader from '@/components/Loader.vue';

@Component({
  components: {
    Loader,
    AnimalSubscribe,
    S3Image,
  },
})
export default class AnimalsList extends Vue {
  private loading: boolean = false;
  @Action('guest/animals/read') private readAnimals!: () => Promise<boolean>;
  @Getter('guest/animals/all') private animals!: any[];

  private mounted() {
    this.loading = true;

    this.readAnimals()
      .then((success) => {
        if (success) {
          this.loading = false;
        } else {
          throw new Error('Some Error, handle it');
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  }

  private goToAnimal(animalId: string) {
    this.$router.push({name: 'GuestAnimal', params: {id: animalId}});
  }
}
